module.exports = new __parcel__URL__("img-placeholder-3.4c5b2358.jpg").toString();